import React, { useState, useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import LanguageIcon from '@mui/icons-material/Language';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useStateValue } from '../../Contexto/store';
import AsignaIdomaEtiquetas from '../../Actions/Generales/IdiomasAction';
import Autorizacion from '../../Actions/Usuarios/AutorizacionAction';
import { EstableceIdiomaUsuario } from '../../Actions/Usuarios/UsuarioAction';
import DiccionarioEtiquetas from '../../Configuracion/Idiomas/Etiquetas_Diccionario';
import withStyles from '@mui/styles/withStyles';
import { styleButtonBar } from '../Tool/Style';

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
));

const Idioma = () => {

    //Estilo de los iconos de la barra
    const classIcon = styleButtonBar();

    const [{ etiquetasIdioma, sesionUsuario, compania }, dispatch] = useStateValue();

    const [anchorEl, setAnchorEl] = useState(null);

    const Cerrar = () => {
        setAnchorEl(null);
    };

    const seleccionaIdiomaCerrar = async (event) => {
        event.preventDefault();
        const { idioma } = event.currentTarget.dataset;
        setAnchorEl(null);
        //Cambio de Idioma
        if (etiquetasIdioma.CodigoIdioma !== idioma) // si el codigo de idima actual es distinto al idioma selecionado
        {
            await EstableceIdiomaUsuario(sesionUsuario.usuario.userId, idioma);
            AsignaIdomaEtiquetas(idioma, dispatch); // Asigna el idioma de las etiquetas estaticas
            Autorizacion(sesionUsuario.usuario.companyId, "11111111-1111-1111-1111-111111111111", sesionUsuario.usuario.userId, idioma, dispatch); // Extrae por medio de la autorizacion del usuario sus etiquetas en el idioma
        }
    };

    const ClickMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    // Se declara la variable de estado que representa al idioma para las etiquetas del componente
    const [etiquetas, setEtiquetas] = useState({
        EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
        CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
    });

    useEffect(() => {
        // se llama al dispatch para que como tal se actualice el reducer
        setEtiquetas({
            EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
            CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
        });

    }, [etiquetasIdioma]);

    return (
        <React.Fragment>
            <Button color="inherit" className={classIcon.Button} onClick={ClickMenu} aria-controls="Idioma-menu" aria-haspopup="true">
                <IconButton
                    className={classIcon.IconButton}
                    style={{ backgroundColor: compania.CfgNavIconBG }}
                    size="large">
                    <LanguageIcon className={classIcon.Icon} style={{ color: compania.CfgNavIconColor }} />
                </IconButton>
                <KeyboardArrowDownIcon className={classIcon.Icon} style={{ color: compania.CfgNavIconColor }} />
            </Button>
            <StyledMenu
                id="Idioma-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={Cerrar}
            >
                <MenuItem data-Idioma={"ES"} onClick={seleccionaIdiomaCerrar}>{etiquetas.EtiquetasComponente.General.Et_lblEs}</MenuItem>
                <MenuItem data-Idioma={"EN"} onClick={seleccionaIdiomaCerrar}>{etiquetas.EtiquetasComponente.General.Et_lblEn}</MenuItem>
            </StyledMenu>
        </React.Fragment>
    );
}

export default Idioma;